export function makeArrayToast(data, type = 1) {
    if (Array.isArray(data)) {
      return data.map(message => ({ message, status: type }));
    }
    
    return [{ message: data, status: type }];
  }
  